import NavBar from "@/components/site/NavBar";
import HeroVSL from "@/components/site/HeroVSL";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

const PRENUP_VIDEO_ID = "6a59ce7ca44a1e6feb43e037";

const headline = (
  <>
    Getting married in OC?{" "}
    <span className="italic text-teal">Protect what you&rsquo;ve built.</span>
  </>
);

const subhead = (
  <>
    A prenuptial agreement isn&rsquo;t about distrust — it&rsquo;s about{" "}
    <span className="text-ink font-medium">clarity</span>.{" "}
    <span className="text-ink font-medium">Binoye Jos, Esq.</span> and the JOS
    Family Law team draft prenups and postnups in Orange County that are
    legally binding to protect what you&rsquo;ve built, based on what you want
    to accomplish. Do you believe it&rsquo;s worth protecting your assets? If
    so, contact us.
  </>
);

const statBar = [
  { num: "80+", label: "Prenups Drafted" },
  { num: "100%", label: "Confidential Process" },
  { num: "1:1", label: "Attorney Attention" },
];

export default function PrenupVSL() {
  return (
    <main data-testid="prenup-vsl-page" className="relative bg-paper text-ink">
      <NavBar />
      <HeroVSL
        videoId={PRENUP_VIDEO_ID}
        headline={headline}
        subhead={subhead}
        statBar={statBar}
      />
      <AttorneyBar />
      <FearSection />
      <FounderStory />
      <GoogleReviews />
      <Testimonials />
      <FinalCTA source="Prenup VSL" />
      <Footer />
    </main>
  );
}
